export default __webpack_public_path__ + "static/media/manual.cd806a40.svg";